import './Badge.css';

// Tons sémantiques (§3.3.7, jetons --ds-badge-*) et états KPI (--ds-kpi-*)
export const BADGE_TONES = ['prim', 'info', 'warn', 'success', 'danger', 'neutral'];
export const BADGE_STATES = ['norm', 'anor', 'crit'];

/**
 * Badge du design system (§3.7) : texte court sur fond teinté, statique. Une seule
 * variante à la fois, par ordre de priorité :
 *  - type : type d'artefact du dictionnaire (§3.3.8 : courbe, histogramme… voir
 *    visuals/typeBadge.jsx), teinte --ds-art-<type>-*, en majuscules ; true : badge de
 *    type sans teinte propre (ton primaire) ;
 *  - state : état KPI ('norm', 'anor', 'crit'), avec un point d'état ;
 *  - count : compteur (nombre en aplat de la couleur primaire) ;
 *  - tone : ton sémantique ('prim', 'info', 'warn', 'success', 'danger', 'neutral' par défaut).
 * icon : icône décorative (le texte porte l'information) ; dot : point d'état (décoratif).
 * label : nom accessible quand le texte visible ne suffit pas (un compteur seul, une
 * abréviation) : lu par les lecteurs d'écran à la place du contenu visible.
 * size : 'sm' (défaut) ou 'md' (texte des cellules de tableau). Autres attributs (aria-hidden,
 * id…) transmis à l'élément.
 */
export function Badge({
  tone = 'neutral',
  state = null,
  type = null,
  count = null,
  icon: Icon = null,
  dot = null,
  label = null,
  size = 'sm',
  title,
  className = '',
  children,
  ...rest
}) {
  let variant;
  if (type) variant = type === true ? 'ds-badge--type' : `ds-badge--type ds-badge--art-${type}`;
  else if (BADGE_STATES.includes(state)) variant = `ds-badge--${state}`;
  else if (count != null) variant = 'ds-badge--count';
  else variant = `ds-badge--${BADGE_TONES.includes(tone) ? tone : 'neutral'}`;
  const showDot = dot ?? BADGE_STATES.includes(state);
  const classes = ['ds-badge', variant, size === 'md' ? 'ds-badge--md' : '', className].filter(Boolean).join(' ');

  const content = (
    <>
      {showDot && <span className="ds-badge__dot" aria-hidden="true" />}
      {Icon && <Icon size={12} />}
      {count ?? children}
    </>
  );
  return (
    <span className={classes} title={title} {...rest}>
      {label ? (
        <>
          <span className="ds-badge__visual" aria-hidden="true">{content}</span>
          <span className="sr-only">{label}</span>
        </>
      ) : content}
    </span>
  );
}
